import { EntityEditor, LazyEditor } from '@tunasong/editor'
import type { EditorContextType } from '@tunasong/editor'
import { ChatEditor } from '@tunasong/plugin-chat/ui'
import { CollabWebsocketEditorYDoc, DynamicEntityEditor, YJSEditor } from '@tunasong/plugin-collab-yjs'
import { NoteEditor } from '@tunasong/plugin-personal-note/note-editor'

export const editorContext: EditorContextType = {
  SongEditor: LazyEditor(CollabWebsocketEditorYDoc, 'song'),
  PageEditor: LazyEditor(CollabWebsocketEditorYDoc, 'page'),
  SongComposeEditor: LazyEditor(CollabWebsocketEditorYDoc, 'songCompose'),
  EntityEditor: LazyEditor(EntityEditor, 'all'),
  DynamicEntityEditor: LazyEditor(DynamicEntityEditor, 'all'),
  DynamicEntityEditorWithoutPlugins: DynamicEntityEditor,
  NoteEditor: LazyEditor(NoteEditor, 'note'),
  ChatEditor: LazyEditor(ChatEditor, 'chat'),
  YJSEditor: LazyEditor(YJSEditor, 'all'),
  PerformanceEditor: LazyEditor(DynamicEntityEditor, 'performance'),
}
